import { AloftDate, FormType, ReportJSON, isDefined } from '@aloft/toolkit-shared';

import { generateTkv2CostDataRptiNodes } from '../createTkv2CostDataRptiNodes.ts';
import { generateOrderInputRptiNodes } from '../generateOrderInputRptiNodes.ts';
import { generateTkv2AdjustmentsRptiNodes } from '../generateTkv2AdjustmentsRptiNodes.ts';
import { generateTkv2UADAnnotationRptiNodes } from '../generateTkv2UADAnnotationRptiNodes.ts';
import { SFREP_FNMA_1004_FORM_CODE } from './consts.ts';

export const create1004LikeFormNode = (
  doc: XMLDocument,
  effectiveDate: AloftDate | undefined,
  compSequence: string[],
  { comps, subject, meta }: ReportJSON,
  formID: string,
): HTMLElement => {
  const fnma1004 = doc.createElement('Form');
  fnma1004.setAttribute('Id', formID);

  const reportFields = doc.createElement('Fields');
  fnma1004.append(reportFields);

  if (isDefined(effectiveDate)) {
    reportFields.append(...generateOrderInputRptiNodes(doc, effectiveDate));
  }

  reportFields.append(
    ...generateTkv2UADAnnotationRptiNodes(doc, {
      property: subject.property,
      isComp: false,
      meta,
    }),
  );

  if (compSequence.length > 0) {
    compSequence.forEach((compId, index) => {
      const comp = comps[compId];
      if (comp) {
        reportFields.append(
          ...generateTkv2UADAnnotationRptiNodes(doc, {
            property: comp,
            isComp: true,
            meta,
            compIndex: index,
          }),
        );
      }
    });
  }

  // Add Cost Approach RPTI nodes from Subject Cost Results
  reportFields.append(...generateTkv2CostDataRptiNodes(doc, subject.costApproach));

  // Add Adjustments each comp
  compSequence.forEach((compId, index) => {
    const comp = comps?.[compId];

    if (comp) {
      reportFields.append(
        ...generateTkv2AdjustmentsRptiNodes(doc, comp, index, FormType.fnma1004, meta),
      );
    }
  });

  fnma1004.appendChild(reportFields);
  return fnma1004;
};

export const create1004FormNode = (
  doc: XMLDocument,
  effectiveDate: AloftDate | undefined,
  compSequence: string[],
  reportJSON: ReportJSON,
) =>
  create1004LikeFormNode(doc, effectiveDate, compSequence, reportJSON, SFREP_FNMA_1004_FORM_CODE);
